import { z } from 'zod'

export const schema = z.object({
  id: z.number(),
  attributes: z.object({
    publishedAt: z.string().nullable(),
    slug: z.string().min(1),
    title: z.string().min(1),
    hero_search: z
      .object({
        author: z.string().min(1).nullable(),
        image: z.object({
          data: z.object({
            attributes: z.object({
              url: z.string().min(1),
            }),
          }),
        }),
        search: z.object({
          filter_type: z.enum(['none', 'provincia', 'comunidad-autonoma']),
          filter_value: z.string().nullable(),
        }),
      })
      .nullable(),
    hero_image: z
      .object({
        image: z.object({
          data: z.object({
            attributes: z.object({
              url: z.string().min(1),
            }),
          }),
        }),
      })
      .nullable(),

    simple_banner: z
      .object({
        text: z.string().min(1),
        button: z
          .object({
            text: z.string().min(1),
            url: z.string().min(1).nullable(),
          })
          .nullable(),
      })
      .nullable(),

    intro_seo_text: z.array(
      z.object({
        title: z.string().min(1),
        text: z.string().min(1),
      }),
    ),
    image_banner: z.array(
      z.object({
        title: z.string().min(1).nullable(),
        text: z.string().min(1),
        button: z
          .object({
            text: z.string().min(1),
            url: z.string().min(1).nullable(),
          })
          .nullable(),
        image: z.object({
          data: z.object({
            attributes: z.object({
              url: z.string().min(1),
            }),
          }),
        }),
      }),
    ),

    featured_destinations: z.array(
      z.object({
        title: z.string().min(1).nullable(),
        card: z.array(
          z.object({
            title: z.string().min(1),
            url: z.string().min(1),
            image: z.object({
              data: z.array(
                z.object({
                  attributes: z.object({
                    url: z.string().min(1),
                  }),
                }),
              ),
            }),
          }),
        ),
      }),
    ),

    media_banner: z.array(
      z.object({
        title: z.string().min(1),
        subtitle: z.string().min(1),
        text: z.string().min(1),
        button: z.object({
          text: z.string().min(1),
          url: z.string().min(1).nullable(),
        }),
        youtube_url: z.string().min(1).nullable(),
        image: z.object({
          data: z
            .object({
              attributes: z.object({
                url: z.string().min(1),
              }),
            })
            .nullable(),
        }),
      }),
    ),

    featured_searches: z.array(
      z.object({
        title: z.string().min(1).nullable(),
        card: z.array(
          z.object({
            title: z.string().min(1),
            url: z.string().min(1),
            image: z.object({
              data: z.array(
                z.object({
                  attributes: z.object({
                    url: z.string().min(1),
                  }),
                }),
              ),
            }),
          }),
        ),
      }),
    ),

    featured_cottages: z.array(
      z.object({
        title: z.string().min(1).nullable(),
        filters: z.string(),
        button: z
          .object({
            text: z.string().min(1),
            url: z.string().min(1).nullable(),
          })
          .nullable(),
      }),
    ),

    featured_posts: z
      .object({
        title: z.string().min(1).nullable(),
        slugs: z.string().min(1),
        button: z
          .object({
            text: z.string().min(1),
            url: z.string().min(1).nullable(),
          })
          .nullable(),
      })
      .nullable(),

    seo_links: z.array(
      z.object({
        title: z.string().min(1).nullable(),
        link: z.array(
          z.object({
            text: z.string().min(1),
            url: z.string().min(1),
          }),
        ),
      }),
    ),
    metadata: z.object({
      id: z.number(),
      title: z.string().min(1),
      description: z.string().min(1),
      image: z.object({
        data: z.object({
          id: z.number(),
          attributes: z.object({
            url: z.string().min(1),
          }),
        }),
      }),
    }),
  }),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  slug: z.string().min(1),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
